/**
 * Render-mode switch for the 2D plan tree: false (default) renders the live
 * editor — hit strips, drag handles, grid, dim bars; true renders the plan as
 * a standalone drawing for export (SVG / DXF downloads), where the same
 * components skip everything interactive and emit pure-attribute SVG.
 */
import { createContext, useContext } from 'react';

export const PlanExportContext = createContext(false);

/** True when rendering for export — skip interactive/chrome elements. */
export const usePlanExport = (): boolean => useContext(PlanExportContext);
